var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 85,
    viewBox: "0 0 72 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_56986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 0.164551H0V72.5609H72V0.164551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 2.8457H2.6665V5.52705H5.33317V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 2.8457H5.33325V5.52705H7.99992V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.8457H8V5.52705H10.6667V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 2.8457H10.667V5.52705H13.3337V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 2.8457H13.3333V5.52705H15.9999V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6669 2.8457H16.0002V5.52705H18.6669V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 2.8457H18.6665V5.52705H21.3332V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 2.8457H24V5.52705H26.6667V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 2.8457H26.6665V5.52705H29.3332V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 2.8457H29.3333V5.52705H31.9999V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 2.8457H32V5.52705H34.6667V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 2.8457H40.0002V5.52705H42.6669V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 2.8457H45.3335V5.52705H48.0002V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 2.8457H50.6665V5.52705H53.3332V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 2.8457H53.3335V5.52705H56.0002V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 2.8457H55.9998V5.52705H58.6664V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 2.8457H58.6667V5.52705H61.3334V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 2.8457H61.3333V5.52705H63.9999V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 2.8457H63.9998V5.52705H66.6664V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 2.8457H66.6667V5.52705H69.3334V2.8457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 5.52734H2.66675V8.20869H5.33341V5.52734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 5.52734H18.6665V8.20869H21.3332V5.52734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 5.52734H32V8.20869H34.6667V5.52734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 5.52734H34.6665V8.20869H37.3332V5.52734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 5.52734H45.3333V8.20869H47.9999V5.52734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 5.52734H50.6665V8.20869H53.3332V5.52734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 5.52734H66.6667V8.20869H69.3334V5.52734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 8.2085H2.6665V10.8898H5.33317V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.2085H8V10.8898H10.6667V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 8.2085H10.667V10.8898H13.3337V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 8.2085H13.3333V10.8898H15.9999V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 8.2085H18.6665V10.8898H21.3332V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 8.2085H26.6665V10.8898H29.3332V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 8.2085H32V10.8898H34.6667V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 8.2085H37.3337V10.8898H40.0004V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 8.2085H40.0002V10.8898H42.6669V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 8.2085H50.6665V10.8898H53.3332V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 8.2085H55.9998V10.8898H58.6664V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 8.2085H58.6667V10.8898H61.3334V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 8.2085H61.3333V10.8898H63.9999V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 8.2085H66.6667V10.8898H69.3334V8.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 10.8896H2.6665V13.571H5.33317V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10.8896H8V13.571H10.6667V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 10.8896H10.667V13.571H13.3337V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 10.8896H13.3333V13.571H15.9999V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 10.8896H18.6665V13.571H21.3332V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 10.8896H29.3333V13.571H31.9999V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 10.8896H32V13.571H34.6667V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 10.8896H37.3337V13.571H40.0004V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 10.8896H40.0002V13.571H42.6669V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 10.8896H42.6667V13.571H45.3334V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 10.8896H45.3335V13.571H48.0002V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 10.8896H50.6665V13.571H53.3332V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 10.8896H55.9998V13.571H58.6664V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 10.8896H58.6667V13.571H61.3334V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 10.8896H61.3333V13.571H63.9999V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 10.8896H66.6667V13.571H69.3334V10.8896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 13.5718H2.6665V16.2531H5.33317V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.5718H8V16.2531H10.6667V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 13.5718H10.667V16.2531H13.3337V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 13.5718H13.3333V16.2531H15.9999V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 13.5718H18.6665V16.2531H21.3332V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 13.5718H29.3333V16.2531H31.9999V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 13.5718H32V16.2531H34.6667V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3329 13.5718H34.6663V16.2531H37.3329V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 13.5718H45.3335V16.2531H48.0002V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 13.5718H50.6665V16.2531H53.3332V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 13.5718H55.9998V16.2531H58.6664V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 13.5718H58.6667V16.2531H61.3334V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 13.5718H61.3333V16.2531H63.9999V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 13.5718H66.6667V16.2531H69.3334V13.5718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 16.2529H2.66675V18.9343H5.33341V16.2529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 16.2529H18.6665V18.9343H21.3332V16.2529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 16.2529H26.6665V18.9343H29.3332V16.2529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 16.2529H32V18.9343H34.6667V16.2529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 16.2529H37.3333V18.9343H39.9999V16.2529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 16.2529H45.3333V18.9343H47.9999V16.2529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 16.2529H50.6665V18.9343H53.3332V16.2529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 16.2529H66.6667V18.9343H69.3334V16.2529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 18.9336H2.6665V21.6149H5.33317V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 18.9336H5.33325V21.6149H7.99992V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 18.9336H8V21.6149H10.6667V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 18.9336H10.667V21.6149H13.3337V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 18.9336H13.3333V21.6149H15.9999V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6669 18.9336H16.0002V21.6149H18.6669V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 18.9336H18.6665V21.6149H21.3332V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 18.9336H24V21.6149H26.6667V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 18.9336H29.3333V21.6149H31.9999V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3329 18.9336H34.6663V21.6149H37.3329V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 18.9336H40.0002V21.6149H42.6669V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 18.9336H45.3335V21.6149H48.0002V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 18.9336H50.6665V21.6149H53.3332V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 18.9336H53.3335V21.6149H56.0002V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 18.9336H55.9998V21.6149H58.6664V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 18.9336H58.6667V21.6149H61.3334V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 18.9336H61.3333V21.6149H63.9999V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 18.9336H63.9998V21.6149H66.6664V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 18.9336H66.6667V21.6149H69.3334V18.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 21.6152H24V24.2966H26.6667V21.6152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 21.6152H26.6665V24.2966H29.3332V21.6152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3329 21.6152H34.6663V24.2966H37.3329V21.6152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 21.6152H37.3337V24.2966H40.0004V21.6152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 21.6152H40.0002V24.2966H42.6669V21.6152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 21.6152H45.3335V24.2966H48.0002V21.6152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 24.2969H2.66675V26.9782H5.33341V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 24.2969H5.33325V26.9782H7.99992V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 24.2969H10.6667V26.9782H13.3334V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 24.2969H13.3333V26.9782H15.9999V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 24.2969H18.6665V26.9782H21.3332V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 24.2969H26.6665V26.9782H29.3332V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 24.2969H34.6665V26.9782H37.3332V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 24.2969H40V26.9782H42.6667V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 24.2969H42.6667V26.9782H45.3334V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 24.2969H50.6665V26.9782H53.3332V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 24.2969H66.6667V26.9782H69.3334V24.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 26.9775H2.66675V29.6589H5.33341V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 26.9775H8V29.6589H10.6667V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 26.9775H16V29.6589H18.6667V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 26.9775H21.3333V29.6589H23.9999V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 26.9775H29.3333V29.6589H31.9999V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 26.9775H42.6667V29.6589H45.3334V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 26.9775H53.3335V29.6589H56.0002V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 26.9775H55.9998V29.6589H58.6664V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 26.9775H58.6667V29.6589H61.3334V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 26.9775H61.3333V29.6589H63.9999V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 26.9775H63.9998V29.6589H66.6664V26.9775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 29.6592H2.66675V32.3405H5.33341V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 29.6592H5.33325V32.3405H7.99992V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 29.6592H8V32.3405H10.6667V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 29.6592H10.6667V32.3405H13.3334V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 29.6592H13.3333V32.3405H15.9999V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 29.6592H16V32.3405H18.6667V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 29.6592H18.6665V32.3405H21.3332V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 29.6592H21.3333V32.3405H23.9999V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6669 29.6592H24.0002V32.3405H26.6669V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 29.6592H26.6665V32.3405H29.3332V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 29.6592H34.6665V32.3405H37.3332V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 29.6592H40V32.3405H42.6667V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 29.6592H42.6667V32.3405H45.3334V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 29.6592H50.6665V32.3405H53.3332V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 29.6592H58.6667V32.3405H61.3334V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 29.6592H66.6667V32.3405H69.3334V29.6592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 32.3413H5.33325V35.0227H7.99992V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 32.3413H8V35.0227H10.6667V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.3413H13.3333V35.0227H15.9999V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 32.3413H21.3335V35.0227H24.0002V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 32.3413H40.0002V35.0227H42.6669V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 32.3413H42.6667V35.0227H45.3334V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 32.3413H50.6665V35.0227H53.3332V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 32.3413H53.3335V35.0227H56.0002V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 32.3413H55.9998V35.0227H58.6664V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 32.3413H58.6667V35.0227H61.3334V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 32.3413H61.3333V35.0227H63.9999V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 32.3413H63.9998V35.0227H66.6664V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 32.3413H66.6667V35.0227H69.3334V32.3413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 35.0215H2.6665V37.7028H5.33317V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 35.0215H8V37.7028H10.6667V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 35.0215H13.3333V37.7028H15.9999V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6669 35.0215H16.0002V37.7028H18.6669V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 35.0215H18.6665V37.7028H21.3332V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 35.0215H26.6665V37.7028H29.3332V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 35.0215H29.3333V37.7028H31.9999V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 35.0215H40.0002V37.7028H42.6669V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 35.0215H45.3335V37.7028H48.0002V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 35.0215H50.6665V37.7028H53.3332V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 35.0215H53.3335V37.7028H56.0002V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 35.0215H66.6667V37.7028H69.3334V35.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 37.7036H2.6665V40.385H5.33317V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 37.7036H5.33325V40.385H7.99992V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 37.7036H10.667V40.385H13.3337V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 37.7036H13.3333V40.385H15.9999V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 37.7036H24V40.385H26.6667V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 37.7036H26.6665V40.385H29.3332V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 37.7036H29.3333V40.385H31.9999V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3329 37.7036H34.6663V40.385H37.3329V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 37.7036H42.6667V40.385H45.3334V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 37.7036H55.9998V40.385H58.6664V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 37.7036H63.9998V40.385H66.6664V37.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 40.3848H2.6665V43.0661H5.33317V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 40.3848H5.33325V43.0661H7.99992V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 40.3848H8V43.0661H10.6667V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 40.3848H10.667V43.0661H13.3337V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 40.3848H13.3333V43.0661H15.9999V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 40.3848H18.6665V43.0661H21.3332V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 40.3848H21.3335V43.0661H24.0002V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 40.3848H29.3333V43.0661H31.9999V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 40.3848H37.3337V43.0661H40.0004V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 40.3848H42.6667V43.0661H45.3334V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 40.3848H48V43.0661H50.6667V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 40.3848H55.9998V43.0661H58.6664V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 40.3848H58.6667V43.0661H61.3334V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 40.3848H61.3333V43.0661H63.9999V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 40.3848H63.9998V43.0661H66.6664V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 40.3848H66.6667V43.0661H69.3334V40.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 43.0664H2.6665V45.7477H5.33317V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 43.0664H10.667V45.7477H13.3337V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 43.0664H13.3333V45.7477H15.9999V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6669 43.0664H16.0002V45.7477H18.6669V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 43.0664H21.3335V45.7477H24.0002V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 43.0664H24V45.7477H26.6667V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3329 43.0664H34.6663V45.7477H37.3329V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 43.0664H42.6667V45.7477H45.3334V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 43.0664H45.3335V45.7477H48.0002V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 43.0664H50.6665V45.7477H53.3332V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 43.0664H53.3335V45.7477H56.0002V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 43.0664H61.3333V45.7477H63.9999V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 43.0664H66.6667V45.7477H69.3334V43.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 45.7476H2.66675V48.4289H5.33341V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 45.7476H8V48.4289H10.6667V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 45.7476H10.6667V48.4289H13.3334V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 45.7476H16V48.4289H18.6667V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 45.7476H18.6665V48.4289H21.3332V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 45.7476H21.3333V48.4289H23.9999V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 45.7476H26.6665V48.4289H29.3332V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 45.7476H32V48.4289H34.6667V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 45.7476H34.6665V48.4289H37.3332V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 45.7476H37.3333V48.4289H39.9999V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 45.7476H45.3333V48.4289H47.9999V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6664 45.7476H47.9998V48.4289H50.6664V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 45.7476H50.6665V48.4289H53.3332V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 45.7476H53.3335V48.4289H56.0002V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 45.7476H55.9998V48.4289H58.6664V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 45.7476H61.3333V48.4289H63.9999V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 45.7476H63.9998V48.4289H66.6664V45.7476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6669 48.4287H24.0002V51.1101H26.6669V48.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 48.4287H29.3333V51.1101H31.9999V48.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 48.4287H32V51.1101H34.6667V48.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 48.4287H45.3333V51.1101H47.9999V48.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 48.4287H55.9998V51.1101H58.6664V48.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 48.4287H63.9998V51.1101H66.6664V48.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 51.1104H2.66675V53.7917H5.33341V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 51.1104H5.33325V53.7917H7.99992V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 51.1104H8V53.7917H10.6667V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 51.1104H10.6667V53.7917H13.3334V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 51.1104H13.3333V53.7917H15.9999V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 51.1104H16V53.7917H18.6667V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 51.1104H18.6665V53.7917H21.3332V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 51.1104H29.3333V53.7917H31.9999V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 51.1104H34.6665V53.7917H37.3332V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 51.1104H45.3333V53.7917H47.9999V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 51.1104H50.6665V53.7917H53.3332V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 51.1104H55.9998V53.7917H58.6664V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 51.1104H58.6667V53.7917H61.3334V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 51.1104H66.6667V53.7917H69.3334V51.1104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 53.792H2.6665V56.4733H5.33317V53.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 53.792H18.6665V56.4733H21.3332V53.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 53.792H32V56.4733H34.6667V53.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 53.792H37.3337V56.4733H40.0004V53.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 53.792H42.6667V56.4733H45.3334V53.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 53.792H45.3335V56.4733H48.0002V53.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 53.792H55.9998V56.4733H58.6664V53.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 53.792H66.6667V56.4733H69.3334V53.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 56.4727H2.66675V59.154H5.33341V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 56.4727H8V59.154H10.6667V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 56.4727H10.6667V59.154H13.3334V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 56.4727H13.3333V59.154H15.9999V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 56.4727H18.6665V59.154H21.3332V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6669 56.4727H24.0002V59.154H26.6669V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 56.4727H32V59.154H34.6667V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 56.4727H34.6665V59.154H37.3332V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 56.4727H40V59.154H42.6667V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 56.4727H42.6667V59.154H45.3334V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 56.4727H45.3333V59.154H47.9999V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6664 56.4727H47.9998V59.154H50.6664V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 56.4727H50.6665V59.154H53.3332V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 56.4727H53.3335V59.154H56.0002V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 56.4727H55.9998V59.154H58.6664V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 56.4727H58.6667V59.154H61.3334V56.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 59.1538H2.6665V61.8352H5.33317V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 59.1538H8V61.8352H10.6667V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 59.1538H10.667V61.8352H13.3337V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 59.1538H13.3333V61.8352H15.9999V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 59.1538H18.6665V61.8352H21.3332V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 59.1538H24V61.8352H26.6667V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3329 59.1538H34.6663V61.8352H37.3329V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 59.1538H48V61.8352H50.6667V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 59.1538H50.6665V61.8352H53.3332V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 59.1538H58.6667V61.8352H61.3334V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 59.1538H63.9998V61.8352H66.6664V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 59.1538H66.6667V61.8352H69.3334V59.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 61.8359H2.6665V64.5173H5.33317V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 61.8359H8V64.5173H10.6667V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 61.8359H10.667V64.5173H13.3337V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 61.8359H13.3333V64.5173H15.9999V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 61.8359H18.6665V64.5173H21.3332V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 61.8359H26.6665V64.5173H29.3332V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 61.8359H32V64.5173H34.6667V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3329 61.8359H34.6663V64.5173H37.3329V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 61.8359H37.3337V64.5173H40.0004V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 61.8359H40.0002V64.5173H42.6669V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 61.8359H45.3335V64.5173H48.0002V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 61.8359H48V64.5173H50.6667V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 61.8359H53.3335V64.5173H56.0002V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 61.8359H55.9998V64.5173H58.6664V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 61.8359H61.3333V64.5173H63.9999V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 61.8359H63.9998V64.5173H66.6664V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 61.8359H66.6667V64.5173H69.3334V61.8359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 64.5161H2.6665V67.1975H5.33317V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 64.5161H18.6665V67.1975H21.3332V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 64.5161H24V67.1975H26.6667V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 64.5161H26.6665V67.1975H29.3332V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 64.5161H29.3333V67.1975H31.9999V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 64.5161H32V67.1975H34.6667V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6669 64.5161H40.0002V67.1975H42.6669V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 64.5161H48V67.1975H50.6667V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 64.5161H53.3335V67.1975H56.0002V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6664 64.5161H55.9998V67.1975H58.6664V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 64.5161H61.3333V67.1975H63.9999V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6664 64.5161H63.9998V67.1975H66.6664V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 64.5161H66.6667V67.1975H69.3334V64.5161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 67.1982H2.66675V69.8796H5.33341V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 67.1982H5.33325V69.8796H7.99992V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 67.1982H8V69.8796H10.6667V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 67.1982H10.6667V69.8796H13.3334V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 67.1982H13.3333V69.8796H15.9999V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 67.1982H16V69.8796H18.6667V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 67.1982H18.6665V69.8796H21.3332V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6669 67.1982H24.0002V69.8796H26.6669V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 67.1982H26.6665V69.8796H29.3332V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 67.1982H32V69.8796H34.6667V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 67.1982H45.3333V69.8796H47.9999V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 67.1982H50.6665V69.8796H53.3332V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 67.1982H58.6667V69.8796H61.3334V67.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 67.1982H66.6667V69.8796H69.3334V67.1982Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6827 83.1641C14.1667 83.1641 15.7867 81.4481 15.7867 79.1681C15.7867 76.9001 14.1667 75.1601 11.6827 75.1601H8.94673V83.1641H11.6827ZM11.6827 82.2761H9.94273V76.0481H11.6827C13.6627 76.0481 14.7547 77.4401 14.7547 79.1681C14.7547 80.8841 13.6267 82.2761 11.6827 82.2761ZM20.1451 83.3081C21.9091 83.3081 23.0131 81.9401 23.0131 80.2601C23.0131 78.5801 21.9091 77.2241 20.1451 77.2241C18.3811 77.2241 17.2771 78.5801 17.2771 80.2601C17.2771 81.9401 18.3811 83.3081 20.1451 83.3081ZM20.1451 82.5041C18.9091 82.5041 18.2131 81.4481 18.2131 80.2601C18.2131 79.0841 18.9091 78.0281 20.1451 78.0281C21.3811 78.0281 22.0651 79.0841 22.0651 80.2601C22.0651 81.4481 21.3811 82.5041 20.1451 82.5041ZM30.6963 83.1641L32.5443 77.3681H31.6083L30.1923 81.9881L28.6683 77.3681H27.9003L26.3763 81.9881L24.9603 77.3681H24.0243L25.8723 83.1641H26.7723L28.2843 78.5081L29.7963 83.1641H30.6963ZM38.7048 83.1641V79.0961C38.7048 77.8361 38.0688 77.2241 36.8568 77.2241C35.9928 77.2241 35.2008 77.7281 34.7928 78.2081V77.3681H33.8928V83.1641H34.7928V78.9281C35.1288 78.4601 35.8008 78.0281 36.5088 78.0281C37.2888 78.0281 37.8048 78.3521 37.8048 79.3721V83.1641H38.7048ZM41.7021 83.1641V75.1601H40.8021V83.1641H41.7021ZM46.3294 83.3081C48.0934 83.3081 49.1974 81.9401 49.1974 80.2601C49.1974 78.5801 48.0934 77.2241 46.3294 77.2241C44.5654 77.2241 43.4614 78.5801 43.4614 80.2601C43.4614 81.9401 44.5654 83.3081 46.3294 83.3081ZM46.3294 82.5041C45.0934 82.5041 44.3974 81.4481 44.3974 80.2601C44.3974 79.0841 45.0934 78.0281 46.3294 78.0281C47.5654 78.0281 48.2494 79.0841 48.2494 80.2601C48.2494 81.4481 47.5654 82.5041 46.3294 82.5041ZM55.4886 83.1641V79.1801C55.4886 77.7761 54.4686 77.2241 53.2446 77.2241C52.2966 77.2241 51.5526 77.5361 50.9286 78.1841L51.3486 78.8081C51.8646 78.2561 52.4286 78.0041 53.1246 78.0041C53.9646 78.0041 54.5886 78.4481 54.5886 79.2281V80.2721C54.1206 79.7321 53.4606 79.4801 52.6686 79.4801C51.6846 79.4801 50.6406 80.0921 50.6406 81.3881C50.6406 82.6481 51.6846 83.3081 52.6686 83.3081C53.4486 83.3081 54.1086 83.0321 54.5886 82.5041V83.1641H55.4886ZM52.9926 82.6601C52.1526 82.6601 51.5646 82.1321 51.5646 81.4001C51.5646 80.6561 52.1526 80.1281 52.9926 80.1281C53.6286 80.1281 54.2406 80.3681 54.5886 80.8481V81.9401C54.2406 82.4201 53.6286 82.6601 52.9926 82.6601ZM62.6928 83.1641V75.1601H61.7928V78.2441C61.3248 77.6081 60.6168 77.2241 59.8368 77.2241C58.3128 77.2241 57.2568 78.4241 57.2568 80.2721C57.2568 82.1561 58.3248 83.3081 59.8368 83.3081C60.6528 83.3081 61.3608 82.8881 61.7928 82.3001V83.1641H62.6928ZM60.0528 82.5041C58.8888 82.5041 58.1928 81.5561 58.1928 80.2721C58.1928 78.9881 58.8888 78.0281 60.0528 78.0281C60.7728 78.0281 61.4688 78.4601 61.7928 78.9641V81.5921C61.4688 82.0961 60.7728 82.5041 60.0528 82.5041Z",
    fill: "#888888"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_56986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72.3963,
    fill: "white",
    transform: "translate(0 0.164551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.e9395f105980f33a1605acdae318c4e8.svg";
export { ForwardRef as ReactComponent };